
import { BusinessUnitEmailContact } from './business-unit-email-contact.model';
import { BusinessUnitEmailContactTypeInfoBase } from './business-unit-email-contact.typeinfo.base';


export class BusinessUnitEmailContactTypeInfo extends BusinessUnitEmailContactTypeInfoBase {

  description(item: BusinessUnitEmailContact): string {
    return '' +  item.description + ' - ' + item.email;
  }

}

export const BUSINESS_UNIT_EMAIL_CONTACT_TYPE: BusinessUnitEmailContactTypeInfo = new BusinessUnitEmailContactTypeInfo();



